<template lang="pug">
    div.expandCard
        table

            // Program Title
            tr
                td {{ $t('fields.programName') }}
                td {{ item.title }}

            // Total meditations add to Program
            tr
                td {{ $t('fields.meditations') }}
                td {{ item.sessionCount }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            item: VueTypes.object.def({})
        }
    };
</script>
